﻿$.fn.dxCtrlCaptchakaAntiSpam = function custom_dxCtrlCaptchakaAntiSpam(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcaptchakaantispam dx-ctrl");
        this.createInstance(new cdxCtrlCaptchakaAntiSpam(this, option));
    }
    return this;
}

window.idxCarousselGeneral = 0
window.cdxCtrlCaptchakaAntiSpam = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    divPuzzleSection = null
    var $DivTextIntro = null
    var $ImgPuzzle = null
    var $ImgPreview = null;
    var dxBtRefresh = null
    var $DivTextFinal = null
    var $DivSpace = null
    function mConstruit() {
        container.empty();
        container.css({
            "display": "flex",
            "align-items": "center",
            "justify-content": "center"
        })
        var $DivContainer = $("<div style='text-align:center;'/>").appendTo(container)

        var urlPub = parametre.urldispatch + "/img/logo/" + parametre.code_appli + "_pubemail42.png"
        var $Img = $("<img src='" + urlPub + "' style='height:42px;position:absolute;bottom:10px;left:10px;cursor:pointer;' alt='Sent with " + parametre.nom + "'/>").appendTo(container)
        $Img.on("click", function () {
            window.open(parametre.urldispatch + "/pageSite.aspx?nb=" + option.bddCtrl.nom_base + "&iddest=" + option.idComDest + "&typ=4", "_blank")
        })

        //var $Table = $("<table style='cursor:pointer;margin:10px;padding:5px 10px;border-radius:10px;' class='state-hover'/>").appendTo(container)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:1px;padding-right:10px;'><img src='" + parametre.img + "' style='width:60px;'/></td>").appendTo($Tr)
        //var $Td = $("<td style='width:1px;white-space:nowrap;font-size:200%;line-height:1;vertical-align:top;' class='dx-theme-accent-as-text-color'>" + parametre.nom + "<br/>" + parametre.phrase + "</td>").appendTo($Tr)
        //$Table.on("click", function (e) {
        //    e.stopPropagation()
        //    window.open(parametre.url_site_vitrine,"_blank")
        //})

        var userLang = navigator.language || navigator.userLanguage;

        var $Table = $("<table style='display:inline-block;'/>").appendTo($DivContainer)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td/>").appendTo($Tr)
        $("<i class='fas fa-envelope-open-text dx-theme-accent-as-text-color' style='display:inline-block;font-size:90px;opacity:0.3;padding-right:5px;'></i>").appendTo($Td)
        if (option.bddCtrl.mGetArray("societe").length > 0) {
            var $Td = $("<td/>").appendTo($Tr)
            var $ImgSoc = $("<img style='width:100px;display:inline-block;'/>").appendTo($Td)
            var obj = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("societe")[0])
            obj.mGetData64Image(function (dataImgUrl) {
                if ((dataImgUrl).length > 0) {
                    $ImgSoc.attr("src", dataImgUrl)
                    if (obj.data.site_web != null && obj.data.site_web.length > 0) {
                        $ImgSoc.css("cursor", "pointer")
                        $ImgSoc.on("click", function () { window.open(obj.data.site_web, "_blank") })
                    }
                }
                else { $ImgSoc.remove() }
            })
        }

        var objEmailRecu = option.bddCtrl.getObjet("com_email_recu", option.idEmailRecu)

        if (typeof objEmailRecu.data == 'undefined' || objEmailRecu.data.id_type_classement != "3") {
            //le mail n'existe plus OU le mail a été distribué
            if (typeof objEmailRecu.data == 'undefined') {
                if (userLang.toLowerCase() == "fr-fr") {
                    $("<div>Votre email n'est plus dans la boite de votre correspondant.</div>").appendTo($DivContainer)
                } else {
                    $("<div>Your message is no longer in the recipient’s inbox.</div>").appendTo($DivContainer)
                }
            } else {
                if (userLang.toLowerCase() == "fr-fr") {
                    $("<div>Votre e-mail a déjà été distribué à votre correspondant.</div>").appendTo($DivContainer)
                } else {
                    $("<div>Your message has been already delivered to the recipient.</div>").appendTo($DivContainer)
                }
            }
        } else {
            var objUti = option.bddCtrl.getObjet("utilisateur", option.id_utilisateur_anti_spam)
            if (userLang.toLowerCase() == "fr-fr") {
                $DivTextIntro = $("<div style='text-align:center;padding-bottom:20px;'/>Pour <b>" + objUti.mGetLib1() + "</b>, chaque correspondant est important.<br/>Pour éviter le spam, le filtre anti-spam de <b><a href='" + parametre.url_site_vitrine + "' target='_blank'>" + parametre.nom + "</a></b> est activé sur ses emails.<br/><br/>Votre email est actuellement en attente de réception.<br/><br/>Pour que votre email soit délivré,<br/>veuillez reconstruire la photo ci-dessous en replaçant les morceaux dans le bon ordre<br/>par un glisser-déplacer conformément au modèle à droite.</div>").appendTo($DivContainer)
            } else {
                $DivTextIntro = $("<div style='text-align:center;padding-bottom:20px;'>For " + objUti.mGetLib1() + ", each contact holds a special place.<br/>In order to avoid spam, spam filter of <b><a href='" + parametre.url_site_vitrine + "' target='_blank'>" + parametre.nom + "</a></b> is enabled on his emails.<br/><br/>Your email is currently awaiting reception.<br/><br/>So that your email is delivered,<br/>please reconstruct the photo below by replacing the pieces in the correct order<br/>using drag and drop according to the model on the right.</div>").appendTo($DivContainer)
            }

            if (userLang.toLowerCase() == "fr-fr") {
                $DivTextFinal = $("<div style='text-align:center;padding-bottom:20px;display:none;'/>Votre e-mail a été distribué à <b>" + objUti.mGetLib1() + "</b>.<br/><br/>Vous faites désormais partie de son réseau de correspondants privilégiés.<br/>Vous n'aurez plus besoin de passer par cette étape pour lui écrire.<br/><br/></div>").appendTo($DivContainer)
            } else {
                $DivTextFinal = $("<div style='text-align:center;padding-bottom:20px;display:none;'>Your message has been delivered to " + objUti.mGetLib1() + ".<br/><br/>You are now part of its privileged correspondent network.<br/>You will no longer need to go through this step to write a message.</div>").appendTo($DivContainer)
            }

            var section = $("<section/>").appendTo($DivContainer)
            var divContentWrapper = $("<div class='contentWrapper' style='width:100%;text-align:center;'/>").appendTo(section)

            divPuzzleSection = $("<div class='puzzleSection' style='display:inline-block;'>").appendTo(divContentWrapper)
            $ImgPuzzle = $('<div id="image"></div>').appendTo(divPuzzleSection)

            $DivSpace = $("<div style='width:15px;display:inline-block;'/>").appendTo(divContentWrapper)

            var divPuzzlePreview = $("<div class='previewSection' style='display:inline-block;'>").appendTo(divContentWrapper)
            $ImgPreview = $("<img src='' style='width:300px;height:300px;'></div>").appendTo(divPuzzlePreview)

            if ($DivContainer.innerWidth() < 600) {
                section.css("transform", "scale(" + ($DivContainer.innerWidth() / 600) + ")")
            }

            $("<br/>").appendTo(divContentWrapper)
            $("<br/>").appendTo(divContentWrapper)
            dxBtRefresh = $("<div style='display:inline-block'/>").appendTo(divContentWrapper).dxCtrlButton({
                icon: "fas fa-refresh",
                txtTooltip: "Choisir une autre image",
                onClick: function (e) {
                    mConstruit()
                }
            }).dxCtrlButton("instance")

            var index = Math.floor((Math.random() * 20) + 1);
            var bg = "/ext/handlerexterne.ashx?command=getimageantispam&nom_base=" + option.bddCtrl.nom_base + "&id=" + index
            //var bg = parametre.url_appli + "/ext/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + index + ".jpg"
            $ImgPreview.attr("src", bg)
            $(".puzzleSection #image").css('background-image', 'url(' + bg + ')');
            $(".previewSection #image").css('background-image', 'url(' + bg + ')');

            startGame()
        }
    }

    //Start game
    function startGame() {
        moves = 0;
        window.moves = 0;
        var classNameArray = ["sq1", "sq2", "sq3", "sq4"];
        var arrayToCompare = [];
        // Images in a array
        var invers1 = Math.floor((Math.random() * 3) + 1);
        while (invers1 == 0) { invers = Math.floor((Math.random() * 3) + 1); }
        var invers2 = invers1 + 1
        var arr = []
        for (var k = 1; k <= 4; k++) {
            if (k == invers1) { arr.push(invers2) }
            else if (k == invers2) { arr.push(invers1) }
            else { arr.push(k) }
        }

        for (i = 0; i < arr.length; i++) {
            $ImgPuzzle.append('<div id="pos' + (i + 1) + '" class="sq' + arr[i] + '"></div>');
        }

        var bg = $(".puzzleSection #image").css('background-image').replace(/^url|[\(\)]/g, '');
        $(".puzzleSection #image div").css('background-image', 'url(' + bg + ')');
        $(".puzzleSection #image").css('background-image', 'none');
        $("#counter span").html("0");

        if (!option.isInSpam) {
            divPuzzleSection.empty()
            mGreat()
        } else {
            $ImgPuzzle.sortable({
                delay: 200,
                stop: function (event, ui) {
                    window.moves++;
                    $("#counter span").html(window.moves);
                    arrayToCompare = [];
                    $ImgPuzzle.children().each(function () {
                        arrayToCompare.push(jQuery(this).attr("class"));
                    });
                    var is_same = (classNameArray.length == arrayToCompare.length) && classNameArray.every(function (element, index) {
                        //return element === arrayToCompare[index];
                        return arrayToCompare[index].startsWith(element)
                    });
                    if (is_same == true) {
                        mGreat()
                        if (typeof option.onValide != 'undefined') option.onValide()
                    }
                }
            });
        }
    }

    function mGreat() {
        //$ImgPuzzle.sortable("destroy");
        $ImgPuzzle.children().css("border", "none")
        divPuzzleSection.animate({ width: 0 }, 300)
        $DivTextIntro.slideUp(300)
        $DivTextFinal.slideDown(300)
        $DivSpace.hide()
        //$ImgPreview.animate({ width: "300px", height: "300px" }, 500)
        dxBtRefresh.element().slideUp(300)
    }

    //function mValide() {
    //    option.bddCtrl.mAjaxCall({
    //        command: "mettreenboitedereceptionfromantispam",
    //        id_com_email_recu: option.idEmailRecu
    //    })
    //}

    function mGetImageCarre(url,funcLoaded) {
        const img = new Image();

        // IMPORTANT pour charger depuis un autre domaine (si CORS autorisé)
        img.crossOrigin = "Anonymous";

        img.onload = function () {
            const size = Math.min(img.width, img.height);

            // Canvas final en 300x300
            const canvas = document.createElement("canvas");
            canvas.width = 300;
            canvas.height = 300;
            const ctx = canvas.getContext("2d");

            // Décalage pour centrer le crop
            const offsetX = (img.width - size) / 2;
            const offsetY = (img.height - size) / 2;

            // On découpe puis on redimensionne directement en 300x300
            ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, 300, 300);

            // Image finale en Base64
            const newImg = canvas.toDataURL("image/jpeg", 0.9);
            funcLoaded(newImg);
        };

        img.src = url;
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}

$('<style>')
    .prop('type', 'text/css')
    .html(`#image {
    width: 300px;
    height: 300px;
    position: relative;
}

#image div {
    width: 300px;
    height: 75px;
    background-repeat: no-repeat;
    float: left;
}

.sq1 {
    background-position: 0 0;
}

.sq2 {
    background-position: 0 33.34%;
}

.sq3 {
    background-position: 0 66.67%;
}

.sq4 {
    background-position: 0 100%;
}

#pos1 {
    top: 0;
    left: 0;
    border-bottom: 1px solid white;
}

#pos2 {
    top: 25%;
    left: 0;
    border-bottom: 1px solid white;
}

#pos3 {
    top: 50%;
    left: 0;
    border-bottom: 1px solid white;
}

#pos4 {
    top: 75%;
    left: 0;
    border-bottom: 1px solid white;
}`)
    .appendTo('head');